import getIdReduxUtil from 'modules/redux/utils/get-id'
import getNameReduxUtil from 'modules/redux/utils/get-name'
import getSlugExerciseNameUtil from 'modules/exercise/utils/get-slug/index.js'

export default function getUrlExerciseUtil (instance) {
  const name = getNameReduxUtil(instance)
  return `/exercises/${getIdReduxUtil(instance)}/${getSlugExerciseNameUtil(name)}`
}
